import { motion } from "framer-motion";
import { SlidersHorizontal, Handshake } from "lucide-react";
import { useI18n } from "@/i18n/LanguageContext";

const EASE = [0.16, 1, 0.3, 1];

const SPANS = ["md:col-span-6", "md:col-span-6"];
const ICONS = [SlidersHorizontal, Handshake];

export default function Bento() {
  const { t } = useI18n();
  const b = t.b2b;

  return (
    <section id="coffee-shops" className="mx-auto max-w-7xl px-4 py-24 sm:px-8 md:py-36">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="mb-16 max-w-2xl"
      >
        <div className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-copper">
          {b.eyebrow}
        </div>
        <h2 className="font-serif text-3xl leading-none tracking-tight text-pine sm:text-5xl">
          {b.titleA} <span className="italic text-copper">{b.titleEm}</span>
        </h2>
        <p className="mt-6 text-base font-light leading-relaxed text-sand sm:text-lg">
          {b.text}
        </p>
      </motion.div>

      <div className="grid grid-cols-12 gap-6" data-testid="b2b-bento-grid">
        {b.items.map((item, i) => {
          const Icon = ICONS[i];
          return (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: EASE }}
              data-testid={`bento-item-${i}`}
              className={`group col-span-12 ${SPANS[i]} flex h-full flex-col justify-between border border-pine/10 bg-paper p-6 shadow-sm transition-all duration-500 hover:border-copper/40 hover:shadow-lg hover:shadow-pine/5 sm:p-10`}
            >
              <div className="flex items-start justify-between gap-4">
                <Icon className="h-6 w-6 shrink-0 text-copper" />
                <div className="text-right">
                  <div className="font-mono text-2xl font-light text-copper sm:text-3xl">
                    {item.metric}
                  </div>
                  <div className="mt-1 font-mono text-[9px] uppercase tracking-[0.2em] text-sand">
                    {item.metricLabel}
                  </div>
                </div>
              </div>
              <div className="mt-10">
                <h3 className="font-serif text-xl text-pine sm:text-2xl">{item.title}</h3>
                <p className="mt-3 text-sm font-light leading-relaxed text-sand">
                  {item.desc}
                </p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
